// extracted by mini-css-extract-plugin
export default {"sections":"consultant-queue-details_sections__XCM3A","grid":"consultant-queue-details_grid__uApXY"};